import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['selector']
  static values = { tableKey: String }

  connect() {
    // Get saved preference from localStorage
    const savedPerPage = this.getPerPageFromStorage()

    // Get the actual count of items rendered on the page
    const actualPerPage = this.getActualPerPage()

    // Set dropdown to saved preference
    this.selectorTarget.value = savedPerPage
    this.updateHiddenInput(savedPerPage)

    // If the server rendered with a different per_page value, reload with localStorage value
    if (actualPerPage && actualPerPage !== savedPerPage) {
      this.resetPageToOne()
      this.submitForm()
    }
  }

  change(event) {
    const newPerPage = event.target.value

    // Save to localStorage
    this.setPerPageInStorage(newPerPage)

    // Update hidden input
    this.updateHiddenInput(newPerPage)

    // Reset page to 1
    this.resetPageToOne()

    // Submit the form to reload table
    this.submitForm()
  }

  updateHiddenInput(value) {
    const form = this.element.closest('form')
    if (!form) return

    let perInput = form.querySelector('input[name="per"]')
    if (!perInput) {
      // Create hidden input if it doesn't exist
      perInput = document.createElement('input')
      perInput.type = 'hidden'
      perInput.name = 'per'
      perInput.dataset.formTarget = 'perInput'
      perInput.dataset.perInput = ''
      form.appendChild(perInput)
    }
    perInput.value = value
  }

  resetPageToOne() {
    const form = this.element.closest('form')
    if (!form) return

    const pageInput = form.querySelector('input[name="page"]')
    if (pageInput) {
      pageInput.value = 1
    }
  }

  submitForm() {
    const form = this.element.closest('form')
    if (!form) return

    // Find the form controller and call its submit method
    const formController = this.application.getControllerForElementAndIdentifier(form, 'form')
    if (formController && formController.submit) {
      formController.submit()
    }
  }

  getStorageKey() {
    return `table_per_page_${this.tableKeyValue}`
  }

  getPerPageFromStorage() {
    const stored = localStorage.getItem(this.getStorageKey())
    return stored || '25' // Default to 25
  }

  setPerPageInStorage(value) {
    localStorage.setItem(this.getStorageKey(), value)
  }

  getActualPerPage() {
    const form = this.element.closest('form')
    if (!form) return null

    const perInput = form.querySelector('input[name="per"]')
    return perInput?.value || '25'
  }
}
